import * as grpcWeb from '@improbable-eng/grpc-web';
import pb from '@aymeric_henry_sr/svelte-proto/credits_pb';
import {
  Credits, type CreditsGetBalance,
} from '@aymeric_henry_sr/svelte-proto/credits_pb_service';

import { GRPC_HOST } from '../../constants/env.constants';
import { unaryTransport } from '../transport';
import { grpcError } from '$lib/utils/grpcError';

const { grpc } = grpcWeb


export async function getCreditsBalance(
  workspaceId: string,
): Promise<{ status: grpc.Code; message: pb.CreditsGetBalanceReply }> {

  return new Promise((resolve, reject) => {
    const req = new pb.CreditsGetBalanceRequest();
    req.setWorkspaceid(workspaceId)
    grpc.unary<pb.CreditsGetBalanceRequest, pb.CreditsGetBalanceReply, CreditsGetBalance>(
      Credits.GetBalance,
      {
        request: req,
        host: GRPC_HOST,
        transport: unaryTransport,
        onEnd: (res) => {
          const { status, statusMessage, message } = res;



          if (status === grpc.Code.OK && message !== null) {
            resolve({
              status,
              message
            });
          }


          reject(grpcError("Get Credits balance", arguments, res))
        }
      }
    );
  });
}


